import { CheckItem } from '@app/models/_index';
import { CourseAvailability } from '@app/enums/_index';
import { Factory } from './_factory';

/**
 * Create Course Availability Check Item Factory used by application
 * Creates instances of Course Availability Check Items
 */
export class CourseAvailabilityCheckItemFactory implements Factory<CheckItem> {
  courses: CheckItem[] = [];

  /**
   * Call and build static Course Availability Check Items array.
   * Do not add or remove items from this array. Used as a read-only reference.
   */
  constructor() {
    this.build();
  }

  /**
   * Build static Course Availability Check Items array.
   */
  build(): void {
    for (const item in CourseAvailability) {
      const course = CourseAvailability[item];
      this.courses.push(new CheckItem(item.toLowerCase(), course, false, course, ''));
    }
  }

  /**
   * Return immutable or copy of Course Availability Check Items collection
   * @returns - a slice or copy of thes static collection
   */
  getCollection(): CheckItem[] {
    if (this.courses && this.courses.length === 0) {
      this.build();
    }
    return this.courses.slice();
  }
}
